import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { getRdvCounts, type RdvCounts } from '../../lib/refonteApi';
import { useAuth } from '../AuthProvider';

/** Barre d'onglets commune aux pages Rendez-vous (hub) : les 3 pages existantes ne bougent pas,
 *  elles partagent une navigation + des compteurs — le travail se voit sans être cherché
 *  (audit UX 09/10 : rafale de statuage à 9h éparpillée sur 3 écrans). */
const tab = ({ isActive }: { isActive: boolean }) =>
  `px-3 py-1.5 rounded-lg text-[12.5px] font-semibold border transition ${isActive ? 'bg-ink text-white border-ink' : 'border-line text-dim hover:border-ink'}`;

const Badge: React.FC<{ n: number }> = ({ n }) =>
  n > 0 ? <span className="ml-1.5 font-mono text-[10px] px-1.5 py-0.5 rounded-full bg-hook-rose/10 text-hook-rose">{n}</span> : null;

const RdvTabs: React.FC<{ showValidate?: boolean }> = ({ showValidate }) => {
  const { profile } = useAuth();
  const canValidate = showValidate ?? ['csm', 'admin', 'super_admin'].includes(profile?.role ?? '');
  const [c, setC] = useState<RdvCounts | null>(null);
  useEffect(() => { getRdvCounts().then(setC).catch(() => {}); }, []);
  return (
    <div className="flex items-center gap-2 flex-wrap mb-4">
      <NavLink to="/app/rdv-a-statuer" className={tab}>À statuer<Badge n={c?.aStatuer ?? 0} /></NavLink>
      <NavLink to="/app/rdv-confirmer" className={tab}>À confirmer (7 j)<Badge n={c?.aConfirmer ?? 0} /></NavLink>
      {canValidate && <NavLink to="/app/rdv-a-valider" className={tab}>À valider (facturation)<Badge n={c?.aValider ?? 0} /></NavLink>}
      <NavLink to="/app/rdv" className={tab} end>Tous les RDV</NavLink>
    </div>
  );
};
export default RdvTabs;
